$("#mc-embedded-subscribe-form").submit(function () {
  $.ajax({
    type: "POST",
    crossDomain: true,
    dataType: "jsonp text",
    url: "https://benjaminedgar.us1.list-manage.com/subscribe/post?u=509323f0b0c218a3accfe2cfd&amp;id=dd0f517834&amp;f_id=006a7ee2f0",
    data: { EMAIL: $("#mce-EMAIL").val() },
  });
  setSubscriptionConfirmedOne();
  return false;
});

function setSubscriptionConfirmedOne() {
  $("#mc-embedded-subscribe-form").css("display", "none");
  $("#mc-embedded-subscribe-form")
    .siblings(".footer-newsletter__copy")
    .css("display", "none");
  $(".confirmed-message").css("display", "block");
}

$("#mc-embedded-subscribe-form-two").submit(function () {
  $.ajax({
    type: "POST",
    crossDomain: true,
    dataType: "jsonp text",
    url: "https://benjaminedgar.us1.list-manage.com/subscribe/post?u=509323f0b0c218a3accfe2cfd&amp;id=dd0f517834&amp;f_id=006a7ee2f0",
    data: { EMAIL: $("#mce-EMAIL2").val() },
  });
  setSubscriptionConfirmedTwo();
  return false;
});

function setSubscriptionConfirmedTwo() {
  $("#mc-embedded-subscribe-form-two").css("display", "none");
  $("#mc-embedded-subscribe-form-two")
    .siblings(".footer-newsletter__copy")
    .css("display", "none");
  $(".confirmed-message-two").css("display", "block");
}
